import NewMessage from './NewMessage';

export default NewMessage;


// WEBPACK FOOTER //
// ./src/pages/chat/chat-messages/new-message/index.js